import React from 'react'

import "./About.css"
function About() {
    return (
        <>
       <div id="about-page">
        <div  id="about">
        <section class="section feature-box mb-5 container">


        <h2 class="text-center text-uppercase my-5 pt-5 wow fadeIn" data-wow-delay="0.2s" style={{color:"#fff", visibility: "visible", animationName: "fadeIn", animationDelay: "0.2s"}}>About <strong>me</strong></h2>

        <p class="text-center w-responsive mx-auto wow fadeIn my-5" data-wow-delay="0.2s" style={{ color:"#fff",fontWeight:"bold",visibility: "visible", animationName: "fadeIn", animationDelay: "0.2s"}}>My name is Ankit Chotaliya,currently I am a student at Vishwakarma govt eng college(VGEC).I love programming and playing with code and new tech learning is my passion</p>


        <div class="row features-big text-center wow fadeIn" data-wow-delay="0.4s" style={{visibility: "visible", animationName: "fadeIn", animationDelay: "0.4s"}}>

           
            <div class="col-md-4 mb-5">

              
                <div class="card card-body hoverable">
                    <i class="fas fa-laptop fa-3x mb-4" aria-hidden="true"></i>
                    <h5 class="font-weight-bold text-uppercase mb-4">Student</h5>
                    <p class="dark-grey-text">Vishwakarma Govt Engineering college</p>
                </div>
                

            </div>
            
            <div class="col-md-4 mb-5">

                
                <div class="card card-body yellow hoverable">
                    <i class="fas fa-code fa-3x mb-4" aria-hidden="true"></i>
                    <h5 class="font-weight-bold text-uppercase mb-4">Developer</h5>
                    <p class="dark-grey-text">Developing new things is my attitude</p>
                </div>
             

            </div>
            
            <div class="col-md-4 mb-5">

           
                <div class="card card-body hoverable">
                    <i class="fas fa-pencil-alt fa-3x mb-4" aria-hidden="true"></i>
                    <h5 class="font-weight-bold text-uppercase mb-4">Designer</h5>
                    <p class="dark-grey-text">I like to design in Adobe xd and more tools</p>
                </div>
      
            </div>
          

        </div>
       

    </section>
    </div> 
    <div class="container-fluid" style={{backgroundColor: "#f3f3f5"}}>
            <div class="container py-4 pt-4">

               
                <section id="skills">

                    
                    <div class="row py-5">

                        
                        <div class="col-lg-6 col-md-12 mb-3 wow fadeIn" data-wow-delay="0.4s" style={{visibility: "visible", animationName: "fadeIn", animationDelay: "0.4s"}}>

                      
                        <div class="d-flex justify-content-start">
                            <h4 class="text-center text-uppercase mb-5 pb-3 mt-4 wow fadeIn" data-wow-delay="0.2s" style={{visibility: "visible", animationName: "fadeIn", animationDelay: "0.2s"}}>My <strong>experience</strong></h4>
                        </div>

                               
                                <blockquote class="blockquote bq-warning mb-4">
                                    <div class="row"> <i class="fas fa-briefcase fa-x mb-1 mr-3 ml-3" aria-hidden="true"></i>
                                        <h5 class="font-weight-bold mb-3">Student</h5>
                                    </div>
                                    <p class="font-weight-bold ml-1 dark-grey-text mb-2">July, 2017 - Present (3 year)</p>
                                    <p class="mb-0 ml-1 light-grey-text">I.p.savani school & VGEC</p>
                                </blockquote>

                                <blockquote class="blockquote bq-warning mt-1 mb-4">
                                    <div class="row"> <i class="fas fa-briefcase fa-x mb-1 mr-3 ml-3" aria-hidden="true"></i>
                                        <h5 class="font-weight-bold mb-3">JavaScript developer</h5> </div>
                                    <p class="font-weight-bold ml-1 dark-grey-text mb-2">June 2019 - Sept 2020 (1 year, 3 Month)</p>
                                    <p class="mb-0 ml-1 light-grey-text">I learned JS and worked with many projects like OLX,Flipkart-Clone and currently I am working on chatbase web apk </p>
                                </blockquote>

                                <blockquote class="blockquote bq-warning">
                                    <div class="row"> <i class="fas fa-briefcase fa-x mb-1 mr-3 ml-3" aria-hidden="true"></i>
                                        <h5 class="font-weight-bold mb-3">Web developer</h5> </div>
                                    <p class="font-weight-bold ml-1 dark-grey-text mb-2"><strong>July - November 2020 (few months)</strong></p>
                                    <p class="mb-0 ml-1 light-grey-text">I learned new tech like MERN stack and MEAN stack </p>
                                </blockquote>

                        </div>
                

                        
                        <div class="col-lg-5 offset-lg-1 col-md-12 mb-4 wow fadeIn" data-wow-delay="0.4s" style={{visibility: "visible", animationName: "fadeIn", animationDelay: "0.4s"}}>

                   
                        <div class="d-flex justify-content-start">
                            <h4 class="text-center text-uppercase mb-5 pb-3 mt-4 wow fadeIn" data-wow-delay="0.2s" style={{visibility: "visible", animationName: "fadeIn", animationDelay: "0.2s"}}>Development <strong>Skills</strong></h4>
                        </div>

                            
                            <p class="black-text text-uppercase font-weight-bold" align="justify">Java Script</p>
                                <div class="md-progress">
                                    <div class="progress-bar bar" role="progressbar" style={{width: "90%" ,backgroundColor:"#facc62"}}aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                            <p class="black-text text-uppercase font-weight-bold pt-3" align="justify">CSS3</p>
                                <div class="md-progress">
                                    <div class="progress-bar bar" role="progressbar" style={{width: "65%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                            <p class="black-text text-uppercase font-weight-bold pt-3" align="justify">HTML5</p>
                                <div class="md-progress">
                                    <div class="progress-bar bar" role="progressbar" style={{width: "75%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                            <p class="black-text text-uppercase font-weight-bold pt-3" align="justify">Bootstrap</p>
                                <div class="md-progress">
                                    <div class="progress-bar bar" role="progressbar" style={{width: "45%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                            <p class="black-text text-uppercase font-weight-bold pt-3" align="justify">MERN-stack</p>
                                <div class="md-progress">
                                    <div class="progress-bar bar" role="progressbar" style={{width: "53%" }} aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                                </div>

                        </div>
                        

                    </div>
              

                </section>
                
          </div>
        </div>
        </div>       
        </>
    )
}

export default About
